module.exports = __webpack_public_path__ + "media/images/clear-2122e7633e20fd07608a4412a51da187.svg";